import axios from "axios";

class ApiBase
{
    async get(uri) {
        const apiBackupBaseA = process.env.REACT_APP_API_BACKUP_A_URL
        const apiBackupBaseB = process.env.REACT_APP_API_BACKUP_B_URL
        try {
            const response = await axios.get(apiBackupBaseA + uri)
            return response.data.data;
        } catch (error) {
            try {
                const response = await axios.get(apiBackupBaseB + uri)
                return response.data.data;
            } catch (error) {

            }
        }
    }
}

export default ApiBase